import { Component, inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-success-subscribe',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './success-subscribe.component.html',
  styleUrl: './success-subscribe.component.scss'
})
export class SuccessSubscribeComponent {
  @Input() thanksMessage: string = '';
  @Input() successMessage: string = '';
  public router = inject(Router);
  public activeModal = inject(NgbActiveModal);

  goToHomePage() {
    this.activeModal.close();
    this.router.navigateByUrl('/home');
  }
}
